import React from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";

function VenueManagerSidebar({ state, setState, menuListData }) {
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const { name, email, user } = loginDetails || {};
  const token = localStorage.getItem("access_token_admin");
  const userLevel = user?.user_level;
  // console.log("nameEamil", name);
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  const shouldShareLoginDetails = (menuTitle) => {
    const menusRequiringLogin = ["Slot Management"];
    return menusRequiringLogin.includes(menuTitle);
  };

  const buildUrlWithLoginParams = (
    baseUrl,
    includeCompleteUserDetails = false
  ) => {
    if (!token) return baseUrl;

    const params = new URLSearchParams({
      access_token: token,
    });

    if (includeCompleteUserDetails && loginDetails) {
      params.append("login_details", JSON.stringify(loginDetails));
    } else {
      if (name) params.append("name", name);
      if (email) params.append("email", email);
      if (userLevel) params.append("user_level", userLevel);
    }

    const paramString = params.toString();
    return (
      baseUrl + (baseUrl?.includes("?") ? `&${paramString}` : `?${paramString}`)
    );
  };

  return (
    <>
      {menuListData?.map((data, index) => {
        let menuClass = data.classsChange;
        if (menuClass === "menu-title") {
          return (
            <li className={menuClass} key={index}>
              {data.title}
            </li>
          );
        } else {
          return (
            <li
              className={` ${state.active === data.title ? "mm-active" : ""}`}
              key={index}
            >
              {data.content && data.content.length > 0 ? (
                <>
                  <Link
                    to={"#"}
                    className="has-arrow"
                    onClick={() => {
                      handleMenuActive(data.title);
                    }}
                  >
                    {data.iconStyle}{" "}
                    <span className="nav-text">
                      {data?.title}
                      {data?.update && data?.update?.length > 0 ? (
                        <span className="badge badge-xs badge-danger ms-2">
                          {data?.update}
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </Link>
                  <Collapse in={state.active === data.title ? true : false}>
                    <ul
                      className={`${
                        menuClass === "mm-collapse" ? "mm-show" : ""
                      }`}
                    >
                      {data.content &&
                        data.content.map((item, index) => {
                          let url = item.to;
                          if (shouldShareLoginDetails(data.title)) {
                            url = buildUrlWithLoginParams(url, true);
                          }
                          return (
                            <li
                              key={index}
                              className={`${
                                state.activeSubmenu === data.title
                                  ? "mm-active"
                                  : ""
                              }`}
                            >
                              {item.content && item.content.length > 0 ? (
                                <>
                                  <Link
                                    to={url}
                                    className={item.hasMenu ? "has-arrow" : ""}
                                    onClick={() => {
                                      handleSubmenuActive(item.title);
                                    }}
                                  >
                                    {item.title}
                                  </Link>
                                  <Collapse
                                    in={
                                      state.activeSubmenu === item.title
                                        ? true
                                        : false
                                    }
                                  >
                                    <ul
                                      className={`${
                                        menuClass === "mm-collapse"
                                          ? "mm-show"
                                          : ""
                                      }`}
                                    >
                                      {item.content &&
                                        item.content.map((data, index) => {
                                          return (
                                            <>
                                              <li key={index}>
                                                <Link
                                                  className={`${
                                                    path === data.to
                                                      ? "mm-active"
                                                      : ""
                                                  }`}
                                                  to={url}
                                                >
                                                  {item.title}
                                                </Link>
                                              </li>
                                            </>
                                          );
                                        })}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <Link to={url}>{item.title}</Link>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </Collapse>
                </>
              ) : (
                <Link
                  to={data.to}
                  onClick={() => {
                    handleMenuActive(data.title);
                  }}
                >
                  {data.iconStyle}
                  <span className="nav-text">{data.title}</span>
                </Link>
              )}
            </li>
          );
        }
      })}
    </>
  );
}

export default VenueManagerSidebar;
